import { defineCommand, defineReceiver } from '@drapejs/invoker';
import { request, query } from '@motillo/drapejs-litium';
import { gql } from 'graphql-request';

export const commands = {
  getGiftcardFavorites: defineCommand<{
    url: string;
    giftcardId: string;
  }>('favorites'),
};

export const receivers = {
  getGiftcardFavorites: defineReceiver(commands.getGiftcardFavorites, async function (command, data) {
    const result = await request(
      this.cache,
      query(
        gql`
         mutation getGiftcardFavorites($url: String!, $giftcardId: String!) {
            session(url: $url) {
              giftcardFavorites{
                giftcardFavoriteProducts(giftcardId: $giftcardId) {
                  products {
                    articleNumber
                    url
                    productName
                    brandName
                    imageIds
                    primaryImage
                    secondaryImage
                    productFlags
                  }
                  tags {
                    key
                    value
                    displayName
                  }
                }
              }
            }
          }
        `
      ),
      {
        url: command.url,
        giftcardId: command.giftcardId,
      }
    );
    return result.data.session;
  },
  'litium'
),
};